// TODO: REFACTORING
import React from 'react';
import Style from './style.module.css';
import BackButton from '../BackButton';
import { translate as t } from '../../utils/translate';
import ShareButton from '../ShareButton';

const AircraftPageOptions = ({ backButton }) => {
  const TEXTS = {
    BACK: t('back'),
  };
  return (
    <div
      className={[
        Style.aircraftPageOptions,
        'container',
        backButton ? '' : Style.noBackOption,
      ].join(' ')}
    >
      <div className={Style.backOptionContainer}>
        <BackButton text={TEXTS.BACK} />
      </div>
      <div className={Style.mainOptions}>
        <ShareButton />
      </div>
    </div>
  );
};

export default AircraftPageOptions;
